<!-- A standardized page title -->
<!-- FUTURE: Make this rely on external CSS classes to customize -->
<script lang="ts" setup>
    import { computed, onMounted, ref } from "vue"
    import {CssLength } from "../lib/CssHelpers"
    import { haveScreenAccess } from "../lib/ChoiceUserConfiguration";
    import MessageSection from "./Messages/MessageSection.vue";
    import { MessageSectionType, DisplayStyle } from '../Enums/UiEnums'
    import '../../css/media.css'
    import { AppScreens } from '../Enums/ChoiceEnums';
    import { hasSlot } from '../lib/VueHelpers';

    const props = withDefaults(defineProps<{
            bottomMargin?: CssLength,
            securityScreenName?: string | AppScreens
        }>(), 
        {
            bottomMargin: () => CssLength.em(1)
    });


    const hasRights = ref<boolean>();

    onMounted(async () => {
        // Determine if the user has rights to view this screen
        if (props.securityScreenName)
            hasRights.value = await haveScreenAccess(props.securityScreenName);
        else 
            hasRights.value = false;
    });

    const compStyle = computed<string|undefined>(() => {
        if (!hasSlot("title") && !hasSlot("farright") && !hasSlot("subtitle"))
            return;

        if (props.bottomMargin)    
            return `margin-bottom:${props.bottomMargin.cssValue}`;
    });

</script>

<style scoped>
    .PageTitle {
        font-size: xx-large;
        color: #204d89;
    }

    .PageSubTitle {
        font-size: large;
        color: #4179c3;
    }
</style>

<template>
    <div :style="compStyle">
        <div class="PageTitle">
            <slot name="title"></slot>

            <span class="float-end mt-2 print-none">
                <slot name="farright"></slot>
            </span>
        </div>

        <div class="PageSubTitle">
            <slot name="subtitle"></slot>
        </div>
    </div>

    <template v-if="securityScreenName">
        <slot name="permitted" v-if="true === hasRights">
        </slot>

        <slot name="restricted" v-if="false === hasRights">
            <MessageSection :type="MessageSectionType.Row" :displayStyle="DisplayStyle.Danger" :showIcon="false">
                You do not have rights to view this screen.
                <div>
                    <MessageSection :type="MessageSectionType.Text" :displayStyle="DisplayStyle.Light" :showIcon="false">
                        ({{securityScreenName}})
                    </MessageSection>
                </div>
            </MessageSection>
        </slot>
    </template>

</template>